<!--  -->
<template>
  <div class="widget-form-container">
    <!-- <div v-if="widgetForm.list.length ===0" class="form-empty">请把组件拖入区域内</div> -->
    <a-form
      :layout="widgetForm.config.layout"
      :labelAlign="widgetForm.config.labelAlign"
      :labelCol="widgetForm.config.labelCol"
      :hideRequiredMark="widgetForm.config.hideRequiredMark"
    >
      <Draggable
        class="widget-form-list"
        item-key="key"
        ghostClass="ghost"
        handle=".drag-widget"
        :animation="200"
        :group="{ name: 'people' }"
        :list="widgetForm.list"
        @add="handleMoveAdd"
      >
        <template #item="{ element, index }">
          <transition-group name="fade" tag="div" class="instruments">
            <WidgetFormItem
              v-if="element.key"
              :key="element.key"
              :element="element"
              :config="widgetForm.config"
              :selectWidget="widgetFormSelect"
              @click="handleItemClick(element)"
              @copy="handleCopyClick(index, widgetForm.list)"
              @delete="handleDeleteClick(index, widgetForm.list)"
            />
          </transition-group>
        </template>
      </Draggable>
    </a-form>
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import Draggable from "vuedraggable";
import { defineComponent, nextTick } from "vue";
import { v4 } from "uuid";
import WidgetFormItem from "./widgetFormItem";
import { useStore } from "vuex";
const handleListInsert = (key, list, obj) => {
  const newList = [];
  list.forEach(item => {
    if (item.key === key) {
      newList.push(item);
      newList.push(obj);
    } else {
      if (item.columns) {
        item.columns = item.columns.map(col => ({
          ...col,
          list: handleListInsert(key, col.list, obj)
        }));
      }
      newList.push(item);
    }
  });
  return newList;
};
const handleListDelete = (key, list) => {
  const newList = [];
  list.forEach(item => {
    if (item.key !== key) {
      if (item.columns) {
        item.columns = item.columns.map(col => ({
          ...col,
          list: handleListDelete(key, col.list)
        }));
      }
      newList.push(item);
    }
  });
  return newList;
};

export default defineComponent({
  components: {
    Draggable,
    WidgetFormItem
  },
  props: {
    widgetForm: {
      type: Object,
      required: true
    },
    widgetFormSelect: {
      type: Object
    },
    widgetFormDisabled: {
      type: Boolean
    }
  },
  setup(props, context) {
    const store = useStore();
    const handleItemClick = row => {
      console.log(row, "ppp");
      store.commit("settings/drawerVisbleChange", true);
      context.emit("update:widgetFormSelect", row);
    };
    const handleDeleteClick = (index, list) => {
      const oldList = JSON.parse(JSON.stringify(props.widgetForm.list));

      if (list.length - 1 === index) {
        if (index === 0) {
          nextTick(() => context.emit("update:widgetFormSelect", null));
        } else {
          context.emit("update:widgetFormSelect", list[index - 1]);
        }
      } else {
        context.emit("update:widgetFormSelect", list[index + 1]);
      }

      context.emit("update:widgetForm", {
        ...props.widgetForm,
        list: handleListDelete(list[index].key, oldList)
      });
    };
    const handleCopyClick = (index, list) => {
      const key = v4().replaceAll("-", "");
      const oldList = JSON.parse(JSON.stringify(props.widgetForm.list));

      let copyData = {
        ...list[index],
        key,
        model: `${list[index].type}_${key}`,
        rules: list[index].rules ?? []
      };

      if (
        list[index].type === "radio" ||
        list[index].type === "checkbox" ||
        list[index].type === "select"
      ) {
        copyData = {
          ...copyData,
          options: {
            ...copyData.options,
            options: copyData.options.options.map(item => ({ ...item }))
          }
        };
      }

      context.emit("update:widgetForm", {
        ...props.widgetForm,
        list: handleListInsert(list[index].key, oldList, copyData)
      });

      context.emit("update:widgetFormSelect", copyData);
    };
    const handleMoveAdd = event => {
      const { newIndex } = event;
      console.log(event, "oooo");

      const key = v4().replaceAll("-", "");
      const list = JSON.parse(JSON.stringify(props.widgetForm.list));

      list[newIndex] = {
        ...list[newIndex],
        key,
        model: `${list[newIndex].type}_${key}`,
        rules: []
      };

      if (
        list[newIndex].type === "radio" ||
        list[newIndex].type === "checkbox" ||
        list[newIndex].type === "select"
      ) {
        list[newIndex] = {
          ...list[newIndex],
          options: {
            ...list[newIndex].options,
            options: list[newIndex].options.options.map(item => ({
              ...item
            }))
          }
        };
      }

      context.emit("update:widgetForm", { ...props.widgetForm, list });
      console.log(list, "listlistlistlistlist");

      context.emit("update:widgetFormSelect", list[newIndex]);
    };
    return {
      handleMoveAdd,
      handleItemClick,
      handleCopyClick,
      handleDeleteClick
    };
  }
});
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.widget-form-container {
  flex: 1;
  .form-empty {
    position: absolute;
    text-align: center;
    width: 300px;
    font-size: 20px;
    top: 450px;
    left: 55%;
    margin-left: -150px;
    color: #ccc;
  }
  .widget-form-list {
    background: #fff;
    border: 1px dashed #999;
    min-height: calc(100vh - 125px);
    margin: 20px;
  }
}
</style>